import { render, staticRenderFns } from "./VideoPublicidad.vue?vue&type=template&id=0ec4d915&"
import script from "./VideoPublicidad.vue?vue&type=script&lang=js&"
export * from "./VideoPublicidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports